import React, { Reducer, useEffect, useReducer, useState } from 'react';
import { useNavigate } from 'react-router';
import { Box, List } from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import {
  useGuestAppFeatureQuery,
  useHotelDetailsQuery,
  usePreRegBookingLazyQuery,
} from '../generated/graphql';
import { ExpandMore } from '../Components/ExpandMore';
import { MainWrapper } from '../Components/MainWrapper';
import { CheckInForm } from './FormComponent/CheckInForm';
import { CheckInView } from './FormComponent/CheckInView';
import Loading from '../Components/Loading/Loading';

interface Props {
  Guest: any;
}

interface IAction<TType = string, TPayload = any> {
  type: TType;
  payload: TPayload;
}

const initialState: Props = { Guest: [] };

const reducer: Reducer<Props, IAction> = (state, action) => {
  switch (action.type) {
    case 'reset':
      return initialState;
    default:
      return { ...state, [action.type]: action.payload };
  }
};

export default function PreCheckIn() {
  const queryParameters = new URLSearchParams(window.location.search);
  const URLBookingID = queryParameters.get('Booking') as string;
  const URLHotelID = queryParameters.get('Hotel') as string;
  const navigate = useNavigate();

  const [state, dispatch] = useReducer(reducer, initialState);
  const [guest, setGuest] = useState<any[]>([]);
  const [expanded, setExpanded] = useState<any[]>([]);

  const {
    loading: HotelLoadings,
    data: { HotelDetails } = { HotelDetails: null },
  } = useHotelDetailsQuery({
    variables: { HotelID: URLHotelID },
    fetchPolicy: 'no-cache',
    onCompleted: data => {
      localStorage.setItem('HotelDetails', JSON.stringify(data.HotelDetails));
      localStorage.setItem('IsPreCheckInPrompt', data.HotelDetails.PreCheckInPrompt as any);
    },
  });

  const {
    loading: GuestAppFeatureLoadings,
    data: { GuestAppFeature } = { GuestAppFeature: null },
  } = useGuestAppFeatureQuery({
    variables: { HotelID: URLHotelID },
    fetchPolicy: 'no-cache',
    onCompleted: data => {
      localStorage.setItem('IsOnlinePayment', data.GuestAppFeature.OnlinePayment as any);
      localStorage.setItem('EnableSelfie', data.GuestAppFeature.EnableSelfie as any);
      localStorage.setItem('SelfCheckin', data.GuestAppFeature.SelfCheckin as any);
      localStorage.setItem('SelfChooseRoom', data.GuestAppFeature.SelfChooseRoom as any);
      localStorage.setItem('PreCheckinAdvTime', String(data.GuestAppFeature.PreCheckinAdvTime ?? 0));
    },
  });

  const [
    PreRegInfo,
    {
      loading: Loadings,
      data: { PreRegBooking } = { PreRegBooking: [] },
    },
  ] = usePreRegBookingLazyQuery({ fetchPolicy: 'no-cache' });

  // const LArrivalDate = JSON.parse(localStorage.getItem('PreRegInfo') as any)?.ArrivalDate
  // const LPreCheckinAdvTime = JSON.parse(localStorage.getItem('PreRegInfo') as any)?.PreCheckinAdvTime  
  const LNAProcessTime = JSON.parse(localStorage.getItem('HotelDetails') as any)?.NAProcessTime 

  const PreCheckinAdvTime = GuestAppFeature?.PreCheckinAdvTime
  const ArrivalDate = PreRegBooking?.ArrivalDate

  const currentDate = new Date();
  const preCheckinAdvTime = PreCheckinAdvTime || 0
  const arrivalDate = ArrivalDate ? new Date(ArrivalDate) : null
  const windowStartDate = arrivalDate
    ? new Date(arrivalDate.getTime() - preCheckinAdvTime * 60 * 60 * 1000)
    : null
  const naHour = LNAProcessTime ? new Date(LNAProcessTime).getHours() : 0
  const naCutoffDate = arrivalDate
    ? new Date(arrivalDate.getFullYear(), arrivalDate.getMonth(), arrivalDate.getDate() + 1, naHour, 0, 0, 0)
    : null
  const dateControl =
    !!arrivalDate &&
    !!windowStartDate &&
    !!naCutoffDate &&
    currentDate >= windowStartDate &&
    currentDate <= naCutoffDate

    console.log('windowStartDate A >>>', windowStartDate)
    console.log('apa A >>>', new Date(arrivalDate!?.getTime() - preCheckinAdvTime * 60 * 60 * 1000))
    console.log('PreCheckinAdvTime A >>>', PreCheckinAdvTime)
    console.log('preCheckinAdvTime A >>>', preCheckinAdvTime)
    console.log('arrivalDate A >>>', arrivalDate)
    console.log('ArrivalDate A >>>', ArrivalDate)
    console.log('PreRegBooking?.ArrivalDate A >>>', PreRegBooking?.ArrivalDate)
    // console.log('LArrivalDate A >>>', LArrivalDate)

    console.log('dateControl 1 >>>', dateControl)
    console.log('preCheckinAdvTime 1 >>>', preCheckinAdvTime)
    console.log('currentDate 1 >>>', currentDate)
    console.log('windowStartDate 1 >>>', windowStartDate)
    console.log('naCutoffDate 1 >>>', naCutoffDate)

  const BookingStatus =
    PreRegBooking?.BookingStatus === 'Cancelled' ||
    PreRegBooking?.BookingStatus === 'NoShow' ||
    PreRegBooking?.BookingStatus === 'CheckOut' ||
    PreRegBooking?.BookingStatus === 'Inhouse';
  const BookingNow = PreRegBooking?.BookingStatus;
  const inhouseRegistrations =
    PreRegBooking?.result?.filter(
      (x: any) => x?.Registrations?.[0]?.RegistrationStatus === 'Inhouse'
    ) || [];
  const hasInhousePasscode = inhouseRegistrations.length > 0;

  const handleExpandClick = (id: any) => {
    const newArray = expanded.map((f: any) => {
      if (f.SharerNo === id) {
        return { ...f, IsExpanded: !f.IsExpanded };
      }
      return { ...f };
    });
    setExpanded(newArray);
  };

  const handlePlus = (i: any) => {
    const guestRoom = state?.Guest?.find((gg: any) => gg.SharerNo === i);
    const noguest = guestRoom?.ContactInfo?.length || 0;
    const maxGuest = expanded.find((ex: any) => ex.SharerNo === i)?.MaxGuest;

    if (noguest >= maxGuest) return;

    const obj = {
      RoomType: guestRoom?.RoomType,
      Order: noguest + 1,
      Mode: 'add',
      SharerNo: guestRoom?.SharerNo,
      FullName: '',
      Email: '',
      NRIC: '',
      BirthDate: new Date(),
      MobileNo: '',
      Nationality: '',
      Address: {},
      SpecialRequest: '',
      IcPhotoFront: '',
      icphotoFront: '',
      IcPhotoBack: '',
      icphotoBack: '',
      IsTerm: false,
      IsPDPA: false,
      IsSignature: false,
      SignatureUrl: null,
      blob: null,
    };

    const newArr = state?.Guest?.map((g: any) => {
      if (g.SharerNo === i) {
        return {
          ...g,
          ContactInfo: [...g.ContactInfo, obj].sort((a: any, b: any) => a.Order - b.Order),
        };
      }
      return { ...g };
    });

    dispatch({ type: 'Guest', payload: newArr });
    setGuest(newArr);
  };

  const handleMinus = (SharerNo: any) => {
    const guestRoom = state?.Guest?.find((y: any) => y?.SharerNo === SharerNo);
    const ContactInfoLength: number = guestRoom?.ContactInfo?.length || 0;

    if (ContactInfoLength <= 1) return;

    const removedIndex = ContactInfoLength - 1;
    const guestKey = `${SharerNo}-${removedIndex}`;
    const UpdatedList = guestRoom?.ContactInfo?.filter(
      (item: any) => item.Order !== ContactInfoLength
    );
    const AllGuest = state?.Guest?.map((g: any) => {
      if (g.SharerNo === SharerNo) {
        return { ...g, ContactInfo: UpdatedList };
      }
      return { ...g };
    });

    dispatch({ type: 'Guest', payload: AllGuest });
    setGuest(AllGuest);
  };

  useEffect(() => {
    if (URLHotelID !== null && URLBookingID !== null) {
      PreRegInfo({
        variables: {
          HotelID: URLHotelID,
          BookingID: URLBookingID,
        },
      });
      localStorage.removeItem('SelectedRoom');
      localStorage.removeItem('ReceiptNo');
      localStorage.removeItem('CheckOutID');
    }
  }, [URLHotelID, URLBookingID]);

  useEffect(() => {
    const arr = PreRegBooking?.result?.map((t: any) => ({
      ID: t.RoomType,
      SharerNo: t.SharerNo,
      IsExpanded: false,
      MaxGuest: t.Registrations[0]?.RoomType?.MaxGuest,
    })) ?? [];
    setExpanded(arr);
  }, [PreRegBooking]);

  useEffect(() => {
    if (PreRegBooking && guest.length === 0) {
      const sorted = PreRegBooking?.result
        ?.slice()
        ?.sort((a, b) => a.Registrations[0]?.SharerNo - b.Registrations[0]?.SharerNo);

      const GuestArr = sorted?.map((t: any, i: number) => ({
        ContactInfo: t.Registrations.map((y: any, i2: number) => ({
          Registration: y?.ID,
          ContactID: y?.Guest?.ContactID,
          ArrivalDate: y?.ArrivalDate,
          DepartureDate: y?.DepartureDate,
          Order: i2 + 1,
          RoomType: t.RoomType,
          RoomDescription: y.RoomType?.Description,
          OldFullName: y.Guest?.Contact?.FullName,
          OldNRIC: y.Guest?.Contact?.NRIC,
          FullName: y.Guest?.Contact?.FullName,
          Email: y.Guest?.Contact?.Email,
          NRIC: y.Guest?.Contact?.NRIC,
          BirthDate: y.Guest?.Contact?.BirthDate,
          MobileNo: y.Guest?.Contact?.MobileNo,
          Nationality: y.Guest?.Contact?.Nationality,
          Address: y.Guest?.Contact?.Address,
          IcPhotoFront: y.Guest?.ICGallery,
          icphotoFront: '',
          IcPhotoBack: y.Guest?.ICBackGallery,
          icphotoBack: '',
          IsTerm: false,
          IsPDPA: false,
          IsSignature: false,
          SignatureUrl: y?.Signature,
          blob: null,
          SpecialRequest: y?.SpecialRequest,
          Gallery: y?.Gallery,
        })),
        RoomType: t.RoomType,
        SharerNo: t.SharerNo,
        IsPreCheckIn: t.IsPreCheckIn,
        IsPreRegistration: t.IsPreRegistration
      })) ?? [];

      setGuest(GuestArr);
      dispatch({ type: 'Guest', payload: GuestArr });
    }
  }, [PreRegBooking]);

  // useEffect(() => {
  //   if (!URLHotelID || !URLBookingID || dateControl || BookingStatus === true) {
  //     navigate('/missing-booking-info');
  //   }
  // }, [URLHotelID, URLBookingID, dateControl, BookingStatus]);

  // console.log('dateControl >>>', dateControl)
  // console.log('currentDate >>>', currentDate)
  // console.log('windowStartDate >>>', windowStartDate)
  // console.log('arrivalDate >>>', arrivalDate)

  return HotelLoadings || Loadings || GuestAppFeatureLoadings ? (
    <Loading />
  ) : (
    <MainWrapper>
      <Box
        sx={{ p: 2, width: '100%', maxWidth: '800px' }}
        justifyContent="center"
        alignItems="center"
        margin="auto"
        bgcolor="#F7FAF7"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" mb="12px" alignItems="center" justifyContent="center">
              <img
                src={HotelDetails?.LogoImage?.ImageURL as any}
                alt="Hotel Logo"
                loading="lazy"
                width="180px"
              />
            </Box>
            <Typography fontSize="17px" fontWeight={600} mb="8px" align="center">
              Pre Check In
            </Typography>
            <Typography fontSize="13px" fontWeight={500} mb="12px" color="black" align="center">
              Kindly complete the form below
            </Typography>
          </Grid>
        </Grid>

        <Box display="flex" height={20} mb="12px">
          <Typography fontSize="14px" fontWeight={600}>
            Booking Info
          </Typography>
        </Box>
        <Card
          sx={{
            mb: '14px',
            borderRadius: '4px',
            boxShadow:
              '0 3px 1px -2px transparent, 2px 5px 4px -2px rgb(0 0 0 / 15%), -2px -1px 4px -2px rgb(0 0 0 / 15%)',
          }}
        >
          <CardContent sx={{ ':last-child': { p: '10px' } }}>
            <Box width="100%" display="flex" mb="10px">
              <Box width="50%" display="flex">
                <Typography fontSize="14px" fontWeight={500} color="black" align="left">
                  Booking No.
                </Typography>
              </Box>
              <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                <Typography fontSize="14px" fontWeight={500} color="secondary">
                  {PreRegBooking?.BookingNo}
                </Typography>
              </Box>
            </Box>
            <Box width="100%" display="flex">
              <Box width="50%" display="flex" alignItems="center">
                <Typography fontSize="14px" fontWeight={500} color="black">
                  No of Room(s)
                </Typography>
              </Box>
              <Box width="50%" display="flex" sx={{ flexDirection: 'row-reverse' }}>
                <Typography fontSize="14px" fontWeight={500} color="secondary">
                  {PreRegBooking?.result?.filter(
                    x => x?.Registrations?.[0]?.RegistrationStatus !== 'Cancelled'
                  )?.length || 0}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card
          sx={{
            mb: '14px',
            borderRadius: '4px',
            boxShadow:
              '0 3px 1px -2px transparent, 2px 5px 4px -2px rgb(0 0 0 / 15%), -2px -1px 4px -2px rgb(0 0 0 / 15%)',
            opacity: hasInhousePasscode ? 1 : 0.5,
          }}
        >
          <CardActions
            disableSpacing
            onClick={() => {
              if (!hasInhousePasscode) return;
              navigate(
                `/pre-checkin/form/information?Hotel=${URLHotelID}&Booking=${URLBookingID}`,
                {
                  state: {
                    Registrations: inhouseRegistrations,
                  },
                }
              );
            }}
            sx={{
              backgroundColor: '#fff4dc',
              cursor: hasInhousePasscode ? 'pointer' : 'not-allowed',
              p: '12px 14px',
              pointerEvents: hasInhousePasscode ? 'auto' : 'none',
              '&:hover': hasInhousePasscode ? { backgroundColor: '#ffefcf' } : undefined,
            }}
          >
            <Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" alignItems="center">
                <VpnKeyIcon
                  sx={{
                    fontSize: 18,
                    color: hasInhousePasscode ? '#ff9800' : '#bdbdbd',
                    mr: '8px',
                  }}
                />
                <Typography
                  fontSize="14px"
                  fontWeight={600}
                  color={hasInhousePasscode ? '#ff9800' : '#bdbdbd'}
                >
                  Passcode Information
                </Typography>
              </Box>
              <KeyboardArrowRightIcon
                sx={{ fontSize: 20, color: hasInhousePasscode ? 'black' : '#bdbdbd' }}
              />
            </Box>
          </CardActions>
        </Card>

        <Typography fontSize="14px" fontWeight={600} mb="10px">
          Registration Info
        </Typography>
        <List className="core-list reset-listitem">
          <div className="rm-padding p-10">
            {PreRegBooking?.result
              ?.filter((x: any) =>
                x?.Registrations?.some(r => r.RegistrationStatus !== 'Cancelled')
              )
              ?.map((x: any, i: number) => {
                const checkPayment = x?.Registrations?.filter(
                  r => r.IsPrincipal === true
                )[0]?.AdvancePayment?.filter(
                  adv => adv.PaymentType === 'CityLedger' && adv.PaymentStatus === 'Paid'
                );

                return ((x?.IsPreRegistration === true && dateControl === false) || (x?.IsPreRegistration === true && x?.IsPreCheckIn === true && (checkPayment?.length > 0 || x?.IsCms === true))) ? (
                // && (checkPayment?.length > 0 || GuestAppFeature?.OnlinePayment === false) 
                  <CheckInView
                    key={x?.SharerNo}
                    state={x}
                    index={i}
                    ExpandMore={ExpandMore}
                    expanded={expanded}
                    handleExpandClick={handleExpandClick}
                    HotelDetails={HotelDetails}
                    localState={state}
                    URLHotelID={URLHotelID}
                    URLBookingID={URLBookingID}
                    SharerNo={x?.SharerNo}
                    BookingNo={PreRegBooking?.BookingNo}
                    IsOnlinePayment={GuestAppFeature?.OnlinePayment}
                    SelfCheckin={GuestAppFeature?.SelfCheckin}
                    SelfChooseRoom={GuestAppFeature?.SelfChooseRoom}
                    EnableSelfie={GuestAppFeature?.EnableSelfie}
                    PreCheckinAdvTime={GuestAppFeature?.PreCheckinAdvTime}
                    PreRegAdvTime={GuestAppFeature?.PreRegAdvTime}
                    ArrivalDate={PreRegBooking?.ArrivalDate}
                    IsCms={x?.IsCms}
                  />
                ) : (
                  <CheckInForm
                    key={x?.SharerNo}
                    state={x}
                    index={i}
                    ExpandMore={ExpandMore}
                    expanded={expanded}
                    handleExpandClick={handleExpandClick}
                    dispatch={dispatch}
                    HotelDetails={HotelDetails}
                    handlePlus={handlePlus}
                    handleMinus={handleMinus}
                    localState={state}
                    URLHotelID={URLHotelID}
                    URLBookingID={URLBookingID}
                    SharerNo={x?.SharerNo}
                    IsOnlinePayment={GuestAppFeature?.OnlinePayment}
                    BookingStatus={BookingStatus}
                    Status={BookingNow}
                    SelfCheckin={GuestAppFeature?.SelfCheckin}
                    SelfChooseRoom={GuestAppFeature?.SelfChooseRoom}
                    EnableSelfie={GuestAppFeature?.EnableSelfie}
                    PreCheckinAdvTime={GuestAppFeature?.PreCheckinAdvTime}
                    PreRegAdvTime={GuestAppFeature?.PreRegAdvTime}
                    ArrivalDate={PreRegBooking?.ArrivalDate}
                  />
                );
              })}
          </div>
        </List>
      </Box>
    </MainWrapper>
  );
}
